import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['phone'];

  connect() {
    this.phoneTarget.addEventListener('keydown', (e) => {
      // Backspace should follow the default behaviour
      if (e.key === 'Backspace' || isNaN(parseInt(e.key))) return;

      // Ensure we only have numbers inputted
      let inputValue = e.target.value.replace(/\D/g, '');
      // Limit adding more characters than the fax number pattern.
      if (inputValue.length > 9) {
        inputValue = inputValue.slice(0, -1);
      }
      // Update input based on the regex pattern
      e.target.value = inputValue.replace(/(\d{3})(\d{1,3})?(\d{1,4})?/, '$1-$2-$3').replace(/-$/, '');
    });
  }
}
